import { Box, Button, Flex, IconButton } from '@chakra-ui/react';
import { MdClose } from 'react-icons/md';
import { useState } from 'react';

import { QueryTable } from '@app/components/common/table';
import { useAlert, useApi } from '@app/hooks';
import { SelectField, TextField } from '@app/components/common';

import Dialog from '../../common/modals/dialog';

const statusOptions = [
  { id: 5, name: 'Закрыта/ложный вызов' },
  { id: 11, name: 'Закрыта/неверно оформлена заявка' },
];

export const CancelModal = ({
  variant = 'icon',
  id,
  onDone,
  onClose,
}: {
  variant?: 'icon' | 'button';
  id: string;
  onDone?(): void;
  onClose?(): void;
}) => {
  const api = useApi();
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { refetch } = QueryTable.useQueryTable();
  const { info } = useAlert();
  
  const [comment, setComment] = useState('');
  const [status, setStatus] = useState<EntityBase>(statusOptions[0]);


  const onSubmit = async () => {
    try {
      setLoading(true);
      const response = await api.equipments.cancelEquipmentsRepair(id, Number(status.id), comment);
      if (response.code === 200) {
        info(response.message);
        refetch();
        onDone?.();
      }

    } catch (e) {
      console.error(e);
      onClose?.();
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      {variant === 'icon' && <IconButton onClick={() => setOpen(true)} isLoading={loading} aria-label="status-edit">
        <MdClose />
      </IconButton>}
      {variant === 'button' && <Button colorScheme='red' onClick={() => setOpen(true)} >Отклонить</Button>}
      <Dialog
        open={isOpen}
        onClose={() => setOpen(false)}
        title="Закрыть заявку"
        actions={
          <Flex justifyContent="space-between" flex={1}>
            <Button colorScheme='red' onClick={onSubmit}>Закрыть</Button>
            <Button variant='ghost' onClick={() => setOpen(false)}>Отмена</Button>
          </Flex>
        }
        loading={loading}
      >
        <Flex flexDirection='column' gap={4}>
          <TextField 
            multiline
            rows={4}
            id=""
            label="Комментарий"
            value={comment}
            onChange={setComment}
          />
          <SelectField
            id='status'
            name='status'
            label='Статус'
            value={status}
            options={statusOptions}
            onChange={setStatus}
            clearable={false}
          />

        </Flex>
      </Dialog>
    </>
  );
};
